module.exports = __webpack_public_path__ + "resources/img/logo_partner_game_17.d941cc0f510cb6ff2732ff98ac4a4508.png";